import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "" }
const _hoisted_2 = ["disabled"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_text_field = _resolveComponent("text-field")
  const _component_progress_overlay = _resolveComponent("progress-overlay")
  const _component_modal_box = _resolveComponent("modal-box")

  return (_openBlock(), _createBlock(_component_modal_box, {
    "is-visible": $data.isVisible,
    title: _ctx.Resources.Comments.SetNicknameModalTitle,
    icon: "user",
    onAfterEnter: $options.onOpen
  }, {
    actions: _withCtx(() => [
      _createElementVNode("a", {
        href: "",
        class: "gfu-link gfu-link--accent _ttl",
        onClick: _cache[1] || (_cache[1] = _withModifiers((...args) => ($options.close && $options.close(...args)), ["prevent"])),
        "data-qa": "modal-button:Cancel"
      }, _toDisplayString(_ctx.Resources.Common.ModalCancelButton), 1 /* TEXT */),
      _createElementVNode("button", {
        type: "button",
        disabled: $options.hasErrors,
        class: "gfu-btn gfu-btn--accent gfu-btn--soft gfu-btn--wide gfu-btn--compact _ml-3",
        onClick: _cache[2] || (_cache[2] = _withModifiers((...args) => ($options.submit && $options.submit(...args)), ["prevent"])),
        "data-qa": "modal-button:Save"
      }, _toDisplayString(_ctx.Resources.Common.ModalSaveButton), 9 /* TEXT, PROPS */, _hoisted_2)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, _toDisplayString(_ctx.Resources.Comments.SetNicknameModalParagraph), 1 /* TEXT */),
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_text_field, {
          ref: "input",
          modelValue: $data.nickname,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => (($data.nickname) = $event)),
          "display-name": _ctx.Resources.Comments.SetNicknameModalNicknameFieldLabel,
          name: "nickname",
          onKeyup: _withKeys(_withModifiers($options.submit, ["prevent","stop"]), ["enter"]),
          "data-qa": "modal-field:NickName"
        }, null, 8 /* PROPS */, ["modelValue", "display-name", "onKeyup"])
      ]),
      _createVNode(_component_progress_overlay, { visible: _ctx.isProcessing }, null, 8 /* PROPS */, ["visible"])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["is-visible", "title", "onAfterEnter"]))
}